(function () {
    function initScrollDetect() {
        var header = document.getElementById('site-header');
        if (!header) return;

        function checkScroll() {
            if ((window.pageYOffset || window.scrollY) > 10) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        }

        window.addEventListener('scroll', checkScroll);
        checkScroll();
    }

    function initSubheaderDropdown() {
        var dropdowns = document.querySelectorAll('.lgnd-subheader-dropdown');
        dropdowns.forEach(function (dropdown) {
            var activeTitle = dropdown.querySelector('.js-subheader-active-title');
            var defaultTitle = activeTitle ? activeTitle.textContent : '';
            var allBtn = dropdown.querySelector('.lgnd-subheader-all-btn');
            var catItems = dropdown.querySelectorAll('.lgnd-subheader-cat-item');
            var panels = dropdown.querySelectorAll('.lgnd-subheader-child-panel');

            function setActivePanel(index, titleText) {
                catItems.forEach(function (item) {
                    if (item.getAttribute('data-index') === index) {
                        item.classList.add('is-hovered');
                    } else {
                        item.classList.remove('is-hovered');
                    }
                });

                var matched = false;
                panels.forEach(function (panel) {
                    if (panel.getAttribute('data-panel-index') === index) {
                        panel.classList.add('is-active');
                        matched = true;
                    } else {
                        panel.classList.remove('is-active');
                    }
                });

                if (activeTitle && titleText) {
                    activeTitle.textContent = titleText;
                }
            }

            catItems.forEach(function (item) {
                item.addEventListener('mouseenter', function () {
                    var index = item.getAttribute('data-index');
                    var title = item.getAttribute('data-title');
                    setActivePanel(index, title);
                });
            });

            if (allBtn) {
                allBtn.addEventListener('mouseenter', function () {
                    catItems.forEach(function (i) {
                        i.classList.remove('is-hovered');
                    });
                    panels.forEach(function (p) {
                        p.classList.remove('is-active');
                    });
                    if (activeTitle) {
                        activeTitle.textContent = allBtn.getAttribute('data-title') || defaultTitle;
                    }
                });
            }

            var firstHasChildren = dropdown.querySelector('.lgnd-subheader-cat-item.has-children');
            if (firstHasChildren) {
                var firstIndex = firstHasChildren.getAttribute('data-index');
                var firstPanel = dropdown.querySelector('.lgnd-subheader-child-panel[data-panel-index="' + firstIndex + '"]');
                if (firstPanel) {
                    firstPanel.classList.add('is-active');
                }
            }
        });
    }

    function initDefaultLanguage() {
        var languageItem = document.querySelector('.header-language-trigger[data-english-locale-url]');
        if (!languageItem) return;

        var storageKey = 'legendarios-language-initialized-v2';
        var currentLocale = languageItem.dataset.currentLocale || '';
        var englishUrl = languageItem.dataset.englishLocaleUrl;

        if (localStorage.getItem(storageKey)) return;
        localStorage.setItem(storageKey, 'true');

        if (englishUrl && currentLocale.indexOf('en') !== 0) {
            window.location.replace(englishUrl);
        }
    }

    function saveLanguagePreference() {
        localStorage.setItem('legendarios-language-initialized-v2', 'true');
    }
    function initLanguageSelect() {
        var selects = document.querySelectorAll('.header-language-select, .top-menu-language-mobile-select');
        selects.forEach(function (select) {
            select.addEventListener('change', function () {
                var selectedOption = this.options[this.selectedIndex];
                var rootUrl = selectedOption && selectedOption.dataset.rootUrl;

                if (rootUrl) {
                    saveLanguagePreference();
                    window.location.assign(rootUrl);
                } else if (this.form) {
                    this.form.submit();
                }
            });
        });
    }

    function initHeaderLanguageDropdown() {
        var buttons = document.querySelectorAll('.header-language-dropdown button[name="locale_code"]');
        buttons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();

                var form = this.closest('form');
                if (!form) return;

                var rootUrl = this.dataset.rootUrl;
                if (rootUrl) {
                    saveLanguagePreference();
                    window.location.assign(rootUrl);
                    return;
                }

                form.submit();
            });
        });
    }
    function initHeaderSearchSubbar() {
        var header = document.getElementById('site-header');
        var searchBar = document.getElementById('site-header-search');
        var overlay = document.getElementById('site-header-search-overlay');
        var closeBtn = document.getElementById('header-search-close-btn');
        if (!header || !searchBar) return;

        var searchInput = searchBar.querySelector('input[type="search"]');

        function updatePosition() {
            var rect = header.getBoundingClientRect();
            searchBar.style.top = rect.bottom + 'px';
        }

        function openSearch() {
            updatePosition();
            searchBar.classList.add('is-open');
            if (overlay) overlay.classList.add('is-active');
            document.body.classList.add('header-search-is-open');
            var searchHandle = document.getElementById('site-search-handle');
            if (searchHandle) searchHandle.classList.add('is-active');

            if (searchInput) {
                setTimeout(function () {
                    searchInput.focus();
                }, 100);
            }
        }

        function closeSearch() {
            searchBar.classList.remove('is-open');
            if (overlay) overlay.classList.remove('is-active');
            document.body.classList.remove('header-search-is-open');
            var searchHandle = document.getElementById('site-search-handle');
            if (searchHandle) searchHandle.classList.remove('is-active');
            if (searchInput) searchInput.blur();
        }

        function toggleSearch() {
            if (searchBar.classList.contains('is-open')) {
                closeSearch();
            } else {
                openSearch();
            }
        }

        // Intercept search clicks in capture phase to prevent sidebar drawer from opening
        document.addEventListener('click', function (e) {
            var searchTrigger = e.target.closest('#site-search-handle, .site-search-handle, a[href="#search"]');
            if (searchTrigger) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                toggleSearch();
                return;
            }

            var closeTrigger = e.target.closest('.header-search-close-btn, #header-search-close-btn, .search-results-close-btn');
            if (closeTrigger) {
                e.preventDefault();
                closeSearch();
                return;
            }

            if (overlay && e.target === overlay) {
                e.preventDefault();
                closeSearch();
                return;
            }
        }, true);

        // Escape key closes search
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
                closeSearch();
            }
        });

        // Ensure Enter navigates to search URL
        if (searchInput) {
            searchInput.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    var q = searchInput.value.trim();
                    if (q) {
                        e.preventDefault();
                        var searchUrl = window.search_url || '/search';
                        window.location.href = searchUrl + '?q=' + encodeURIComponent(q);
                    }
                }
            });
        }

        // Form submit fallback
        var searchForm = searchBar.querySelector('form.search-bar');
        if (searchForm) {
            var submitBtn = searchForm.querySelector('button[type="submit"]');
            if (submitBtn) {
                submitBtn.addEventListener('click', function (e) {
                    var q = searchInput ? searchInput.value.trim() : '';
                    if (q) {
                        e.preventDefault();
                        var searchUrl = window.search_url || '/search';
                        window.location.href = searchUrl + '?q=' + encodeURIComponent(q);
                    }
                });
            }
        }

        // Update position dynamically
        window.addEventListener('resize', function () {
            if (searchBar.classList.contains('is-open')) {
                updatePosition();
            }
        });
        window.addEventListener('scroll', function () {
            if (searchBar.classList.contains('is-open')) {
                updatePosition();
            }
        });
    }

    function initPreservePreviewAndCleanLinks() {
        var currentParams = new URLSearchParams(window.location.search);
        var previewThemeId = currentParams.get('preview_theme_id');

        function cleanAndPreserveLink(anchor) {
            if (!anchor) return;
            var href = anchor.getAttribute('href');
            if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) {
                return;
            }

            try {
                // If link is an absolute URL to this store domain, clean to relative
                if (href.indexOf('shop.loslegendarios.org') !== -1 || href.indexOf('loslegendarios.org') !== -1) {
                    var parsed = new URL(href, window.location.origin);
                    if (previewThemeId && !parsed.searchParams.has('preview_theme_id')) {
                        parsed.searchParams.set('preview_theme_id', previewThemeId);
                    }
                    anchor.setAttribute('href', parsed.pathname + parsed.search + parsed.hash);
                    return;
                }

                // If preview theme is active, ensure internal relative links preserve it
                if (previewThemeId) {
                    var targetUrl = new URL(anchor.href, window.location.origin);
                    if (targetUrl.hostname === window.location.hostname || targetUrl.hostname.indexOf('loslegendarios.org') !== -1 || targetUrl.hostname.indexOf('myshopify.com') !== -1) {
                        if (!targetUrl.searchParams.has('preview_theme_id')) {
                            targetUrl.searchParams.set('preview_theme_id', previewThemeId);
                            if (href.startsWith('/')) {
                                anchor.setAttribute('href', targetUrl.pathname + targetUrl.search + targetUrl.hash);
                            } else {
                                anchor.setAttribute('href', targetUrl.toString());
                            }
                        }
                    }
                }
            } catch (err) {}
        }

        function processAllLinks() {
            var anchors = document.querySelectorAll('a[href]');
            anchors.forEach(cleanAndPreserveLink);
        }

        processAllLinks();

        // Capture phase click interceptor to guarantee preview parameter is kept on click
        document.addEventListener('click', function (e) {
            var anchor = e.target.closest('a[href]');
            if (!anchor) return;
            cleanAndPreserveLink(anchor);
        }, true);
    }

    function initAll() {
        initDefaultLanguage();
        initScrollDetect();
        initSubheaderDropdown();
        initLanguageSelect();
        initHeaderLanguageDropdown();
        initHeaderSearchSubbar();
        initPreservePreviewAndCleanLinks();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();